const STORAGE_KEY = 'savedTrailerConfig';

export const saveConfigToStorage = (config) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
};

export const getConfigFromStorage = () => {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : null;
    } catch (e) {
        console.error('Błąd odczytu localStorage:', e);
        return null;
    }
};

export const clearConfigStorage = () => {
    localStorage.removeItem(STORAGE_KEY);
};